var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"login__footer"},[_c('ul',_vm._l((_vm.$t('login.footerLinks')),function(link){return _c('router-link',{key:link,attrs:{"to":("/" + link),"tag":"li"}},[_c('a',[_vm._v(_vm._s(link))])])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }